export const SESSION_STORAGE_KEYS = {
  AUTH0_ACCESS_TOKEN: 'auth0AccessToken',
  MFA_ACCESS_TOKEN: 'mfaAccessToken',
  CSP_ACCESS_TOKEN: 'cspAccessToken',
  PARTNER_NUMBER: 'partnerNumber',
  CONTACT_ID: 'contactId',
  TOKEN_CLAIMS: 'claims',
  OOB_CODE: 'oobCode',
  PET_DETAILS: 'petDetails',
  RENEWAL_HUB: 'renewalHub',
  LIVE_VET_SESSION: 'liveVetSession',
  SHOW_ONBOARDING: 'showOnboarding',
  SHOW_TERMSOFUSE: 'showTermsOfUse',
  INIT_REQUEST_IDS: 'initRequestIds',
  PAYMENT_REFERENCE_NUMBER: 'paymentReferenceNumber',
  IS_FIRST_LOGIN: 'isFirstLogin'
};
